<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  @import './assets/icon/iconfont.css';
  html, body {
    background-color: #f8f8f9;
    padding: 0;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue